import { parseError, agent, updateSessionObject } from 'utils/api'
import { notify } from '../utils/notification'
import constants from 'constants'
import { push } from 'react-router-redux'

export const DOCUMENTS_RECEIVED_DOCUMENTS = 'DOCUMENTS_RECEIVED_DOCUMENTS'
export const DOCUMENTS_GETING_DOCUMENTS = 'DOCUMENTS_GETING_DOCUMENTS'
export const DOCUMENTS_ERROR = 'DOCUMENTS_ERROR'

const fetching = type => ({
  type,
})

const receive = (documents, type) => ({
  type,
  documents,
})

export function getDocuments(libraryName, folderName, employeeid, username, cancelToken) {
  return (dispatch) => {
    dispatch(fetching(DOCUMENTS_GETING_DOCUMENTS))
    agent.Documents.getDocuments(libraryName, folderName, employeeid, username, cancelToken)
      .then((result) => {
        dispatch(receive(result, DOCUMENTS_RECEIVED_DOCUMENTS))
      })
      .catch((rawError) => {
        console.error('Getting documents error')
        // console.error('getDocuments error', rawError, rawError.stack, window.location)
        const { error, status, description } = parseError(rawError)
        if (status === constants.ERROR.INTERNAL_SERVER) {
          dispatch(push({
            pathname: '/error',
            search: `?type=${constants.ERROR.INTERNAL_SERVER}`,
          }))
        } else if (status === constants.ERROR.UNAUTHORIZED) {
          updateSessionObject()
        } else if (error.message === constants.ERROR.CANCEL_REQUEST) {
          console.log('CANCEL_REQUEST')
        } else {
          dispatch(notify(description))
          dispatch(notify('Error fetching documents', 'warning'))
          dispatch(push({ pathname: '/' }))
        }
      })
  }
}

export function deleteDocument(itemid, libraryName, folderName, employeeid, username, cancelToken) {
  return (dispatch) => {
    dispatch(fetching(DOCUMENTS_GETING_DOCUMENTS))
    agent.Documents.deleteDocument(itemid, libraryName, folderName, employeeid, username, cancelToken).then((result) => {
      dispatch(notify('Document deleted'))
      dispatch(receive(result, DOCUMENTS_RECEIVED_DOCUMENTS))
    }).catch((rawError) => {
      const { error, status, description } = parseError(rawError)
      if (status === constants.ERROR.INTERNAL_SERVER || status === constants.ERROR.SERVICE_UNAVAILABLE) {
        dispatch(push({
          pathname: '/error',
          search: `?type=${constants.ERROR.INTERNAL_SERVER}`,
        }))
      } else if (status === constants.ERROR.UNAUTHORIZED) {
        updateSessionObject()
      } else {
        dispatch(notify(description))
        // console.warn('Err <deleteDocument>: ', error)
        dispatch(notify('We are unable to delete the document at this time, please try again later.', 'warning'))
      }
    })
  }
}




// WEBPACK FOOTER //
// ./src/actions/documents.js